import angular from 'angular';

import { routesConfig } from './leads.routes';

import '../activity/AddNoteForm.directive';

export default angular.module('leads', []).config(routesConfig);
